module.exports = __webpack_public_path__ + "static/media/iconfinder_css3_2916226.6c642cac.svg";